module.exports = __webpack_public_path__ + "static/media/box.8aafe44a.svg";